<div class="inline-flex items-center gap-2">
    <span class="text-[13px] font-semibold text-muted">Al:</span>
    <div class="relative inline-flex items-center">
        <i class="fas fa-calendar-alt pointer-events-none absolute left-3 z-10 text-[13px] text-brand-500"></i>
        <input autocomplete="off"
               class="h-9 w-48 cursor-pointer rounded-full border border-brand-200 bg-brand-50 pl-9 pr-4 text-[13px] font-semibold text-ink shadow-sm placeholder:text-muted transition-colors hover:border-brand-400 hover:bg-brand-100 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-400"
               placeholder="gg-mm-aaaa"
               name="dp"
               (click)="datePickerId.toggle()"
               [(ngModel)]="globalData.datePickerFinoA.dataSelezionataFinoA"
               ngbDatepicker #datePickerId="ngbDatepicker">
    </div>
</div>
